import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  FUNDING_FEATURE_KEY,
  // FundingState,
  // fundingAdapter,
} from './funding.reducer';
import {
  IDebitCredit,
  IDepositMoneyPak,
  IDepositCryptoCurrency,
  IDepositDebitCreditCard,
  IDepositPromoCode,
  IFundingState,
  IWithdrawDebitCreditCard,
  IWithdrawCheckByEmail,
  IWithdrawOnlineCheckACH,
  IDepositOnlineCheckACH,
} from './funding.models';
import { ITransactionFeeResponse, TError } from '@amwager/util-ts';

// Lookup the 'Funding' feature state managed by NgRx
// export const selectFundingState =
//   createFeatureSelector<FundingState>(FUNDING_FEATURE_KEY);

// const { selectAll, selectEntities } = fundingAdapter.getSelectors();

// export const selectFundingLoaded = createSelector(
//   selectFundingState,
//   (state: FundingState) => state.loaded
// );

// export const selectFundingError = createSelector(
//   selectFundingState,
//   (state: FundingState) => state.error
// );

// export const selectAllFunding = createSelector(
//   selectFundingState,
//   (state: FundingState) => selectAll(state)
// );

// export const selectFundingEntities = createSelector(
//   selectFundingState,
//   (state: FundingState) => selectEntities(state)
// );

// export const selectSelectedId = createSelector(
//   selectFundingState,
//   (state: FundingState) => state.selectedId
// );

// export const selectEntity = createSelector(
//   selectFundingEntities,
//   selectSelectedId,
//   (entities, selectedId) => (selectedId ? entities[selectedId] : undefined)
// );


// Lookup the 'Funding' feature state managed by NgRx
export const selectFundingState = createFeatureSelector<IFundingState>(
  FUNDING_FEATURE_KEY
);

export const getFundingLoaded = createSelector(
  selectFundingState,
  (state: IFundingState): boolean | undefined => state?.isLoaded
);

export const getFundingError = createSelector(
  selectFundingState,
  (state: IFundingState): TError => state?.error
);

/**
 * Deposit debit credit card
 */
export const getDepositDebitCreditCard = createSelector(
  selectFundingState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (state: IFundingState): any | undefined => state?.depositDebitCreditCard
);

export const getIsDepositDebitCreditCardProcessing = createSelector(
  getDepositDebitCreditCard,
  (funding: IDepositDebitCreditCard | undefined):
    boolean | undefined => funding?.isProcessing || false
);

export const getIsDepositDebitCreditCardSuccess = createSelector(
  getDepositDebitCreditCard,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (funding: IDepositDebitCreditCard | undefined):
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  {response: any, isSuccess: boolean | undefined} => ({
      response: funding?.response,
      isSuccess: funding?.isSuccess
  })
);

/**
 * Withdraw debit credit card
 */
export const getWithdrawDebitCreditCard = createSelector(
  selectFundingState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (state: IFundingState): any | undefined => state?.withdrawDebitCreditCard
);

export const getIsWithdrawDebitCreditCardProcessing = createSelector(
  getWithdrawDebitCreditCard,
  (funding: IWithdrawDebitCreditCard | undefined):
    boolean | undefined => funding?.isProcessing || false
);

export const getIsWithdrawDebitCreditCardSuccess = createSelector(
  getWithdrawDebitCreditCard,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (funding: IWithdrawDebitCreditCard | undefined):
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  {response: any, isSuccess: boolean | undefined} => ({
      response: funding?.response,
      isSuccess: funding?.isSuccess
  })
);

/**
 * Get debit credit card
 */
export const card = createSelector(
  selectFundingState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (state: IFundingState): any | undefined => state?.debitCredit
);

// export const getListCards = createSelector(
//   getCards,
//   // eslint-disable-next-line @typescript-eslint/no-explicit-any
//   (debitCreditCards: IDebitCreditCards | undefined):
//     // eslint-disable-next-line @typescript-eslint/no-explicit-any
//     {response: any} => ({
//       response: debitCreditCards?.cards
//   })
// );

// IDebitCredit
export const getListCards = createSelector(
  card,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (debitCredit: any | undefined): any | undefined => debitCredit?.cards
);

/**
 * Add debit credit card
 */
export const addCardSuccess = createSelector(
  card,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (debitCredit: any | undefined): {response: any, isSuccess: boolean | undefined} => ({
    response: debitCredit?.response,
    isSuccess: debitCredit?.isSuccess
  })
);

/**
 * Delete debit credit card
 */
export const deleteCardSuccess = createSelector(
  card,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (debitCredit: any | undefined): {response: any, isSuccess: boolean | undefined} => ({
    response: debitCredit?.response,
    isSuccess: debitCredit?.isSuccess
  })
);

export const cardFee = createSelector(
  getDepositDebitCreditCard,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (depositDebitCreditCard: IDepositDebitCreditCard | undefined):
    ITransactionFeeResponse | undefined => depositDebitCreditCard?.cardFee
);

/**
 * Deposit promocode
 */
export const getDepositPromoCode = createSelector(
  selectFundingState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (state: IFundingState): any | undefined => state?.depositPromoCode
);
export const getIsDepositPromoCodeProcessing = createSelector(
  getDepositPromoCode,
  (funding: IDepositPromoCode | undefined):
    boolean | undefined => funding?.isProcessing || false
);
export const getIsDepositPromoCodeSuccess = createSelector(
  getDepositPromoCode,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (funding: IDepositPromoCode | undefined):
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  {response: any, isSuccess: boolean | undefined} => ({
    response: funding?.response,
    isSuccess: funding?.isSuccess
  })
);

/**
 * Deposit money pak
 */
export const getDepositMoneyPak = createSelector(
  selectFundingState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (state: IFundingState): any | undefined => state?.depositMoneyPak
);
export const getIsDepositMoneyPakProcessing = createSelector(
  getDepositMoneyPak,
  (funding: IDepositMoneyPak | undefined):
    boolean | undefined => funding?.isProcessing || false
);
export const getIsDepositMoneyPakSuccess = createSelector(
  getDepositMoneyPak,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (funding: IDepositMoneyPak | undefined):
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  {response: any, isSuccess: boolean | undefined} => ({
      response: funding?.response,
      isSuccess: funding?.isSuccess
  })
);

/**
 * Deposit crypto currency
 */
export const getDepositCryptoCurrency = createSelector(
  selectFundingState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (state: IFundingState): any | undefined => state?.depositCryptoCurrency
);

export const getIsDepositCryptoCurrencyProcessing = createSelector(
  getDepositCryptoCurrency,
  (funding: IDepositCryptoCurrency | undefined):
    boolean | undefined => funding?.isProcessing || false
);

export const getIsDepositCryptoCurrencySuccess = createSelector(
  getDepositCryptoCurrency,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (funding: IDepositCryptoCurrency | undefined):
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  {response: any, isSuccess: boolean | undefined} => ({
      response: funding?.response,
      isSuccess: funding?.isSuccess
  })
);

/**
 * Get funding limit
 */
export const fundingLimit = createSelector(
  selectFundingState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (state: IFundingState): any | undefined => state?.fundingLimit
);

export const getFundingLimitList = createSelector(
  fundingLimit,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (fundingLimit: any | undefined): any | undefined => fundingLimit?.list
);

/**
 * Get pending ach
 */
export const pendingAch = createSelector(
  selectFundingState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (state: IFundingState): any | undefined => state?.pendingAch
);

export const getPendingAchList = createSelector(
  pendingAch,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (pendingAch: any | undefined): any | undefined => pendingAch?.list
);

/**
 * Get held withdrawals
 */
export const heldWithdrawals = createSelector(
  selectFundingState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (state: IFundingState): any | undefined => state?.heldWithdrawals
);

export const getHeldWithdrawalsList = createSelector(
  heldWithdrawals,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (heldWithdrawals: any | undefined): any | undefined => heldWithdrawals?.list
);

export const getIsHeldWithdrawalsProcessing = createSelector(
  heldWithdrawals,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (heldWithdrawals: any | undefined):
    boolean | undefined => heldWithdrawals?.isProcessing || false
);

export const getIsHeldWithdrawalsSuccess = createSelector(
  heldWithdrawals,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (heldWithdrawals: any | undefined): {response: any, isSuccess: boolean | undefined} => ({
    response: heldWithdrawals?.response,
    isSuccess: heldWithdrawals?.isSuccess
  })
);

/**
 * Deposit online check ACH
 */
export const getDepositOnlineCheck = createSelector(
  selectFundingState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (state: IFundingState): any | undefined => state?.depositOnlineCheckACH
);

export const getIsDepositOnlineCheckProcessing = createSelector(
  getDepositOnlineCheck,
  (funding: IDepositOnlineCheckACH | undefined):
    boolean | undefined => funding?.isProcessing || false
);

export const getIsDepositOnlineCheckSuccess = createSelector(
  getDepositOnlineCheck,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (funding: IDepositOnlineCheckACH | undefined):
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  {response: any, isSuccess: boolean | undefined} => ({
      response: funding?.response,
      isSuccess: funding?.isSuccess
  })
);

/**
 * Get ach accounts
 */
export const achAccount = createSelector(
  selectFundingState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (state: IFundingState): any | undefined => state?.ach
);

export const getAchAccountList = createSelector(
  achAccount,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (ach: any | undefined): any | undefined => ach?.accounts
);

/**
 * Add ach account
 */
export const addAchAccountSuccess = createSelector(
  achAccount,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (ach: any | undefined): {response: any, isSuccess: boolean | undefined} => ({
    response: ach?.response,
    isSuccess: ach?.isSuccess
  })
);

/**
 * Delete ach account
 */
export const deleteAchAccountSuccess = createSelector(
  achAccount,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (ach: any | undefined): {response: any, isSuccess: boolean | undefined} => ({
    response: ach?.response,
    isSuccess: ach?.isSuccess
  })
);

/**
 * Withdraw debit credit card
 */
export const getWithdrawCheckByEmail = createSelector(
  selectFundingState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (state: IFundingState): any | undefined => state?.withdrawCheckByEmail
);

export const getIsWithdrawCheckByEmailProcessing = createSelector(
  getWithdrawCheckByEmail,
  (funding: IWithdrawCheckByEmail | undefined):
    boolean | undefined => funding?.isProcessing || false
);

export const getIsWithdrawCheckByEmailSuccess = createSelector(
  getWithdrawCheckByEmail,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (funding: IWithdrawCheckByEmail | undefined):
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  {response: any, isSuccess: boolean | undefined} => ({
      response: funding?.response,
      isSuccess: funding?.isSuccess
  })
);

/**
 * Withdraw online check ACH
 */
export const getWithdrawOnlineCheck = createSelector(
  selectFundingState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (state: IFundingState): any | undefined => state?.withdrawOnlineCheckACH
);

export const getIsWithdrawOnlineCheckProcessing = createSelector(
  getWithdrawOnlineCheck,
  (funding: IWithdrawOnlineCheckACH | undefined):
    boolean | undefined => funding?.isProcessing || false
);

export const getIsWithdrawOnlineCheckSuccess = createSelector(
  getWithdrawOnlineCheck,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (funding: IWithdrawOnlineCheckACH | undefined):
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  {response: any, isSuccess: boolean | undefined} => ({
      response: funding?.response,
      isSuccess: funding?.isSuccess
  })
);
